"use strict";
(function(global) {
    class FortifyPreviewController {
        constructor(config) {
            this.settings = {
                charts: {
                    barChart: {
                        chartVulnerabilitiesNumber : {
                            id: "chartVulnerabilitiesNumber",
                            dataName: "vulnerabilities_number"
                        },
                        chartAnalysisNumber : {
                            id: "chartAnalysisNumber",
                            dataName: "analysis_number"

                        },
                        chartCriticalityDistribution : {
                            id: "chartCriticalityDistribution",
                            dataName: "criticality_distribution"

                        }
                    },

                    pieCharts: {
                        chartCriticalityVulnerabilityDistribution: {
                            id: "chartCriticalityVulnerabilityDistribution",
                            dataName: "criticality_vulnerability_distribution"
                        },
                        chartCriticalityVulnerabilityAnalysis: {
                            id: "chartCriticalityVulnerabilityAnalysis",
                            dataName: "criticality_vulnerability_analysis"
                        }
                    }
                },
                colors: {
                    low: "250, 220, 0",
                    medium: "255, 132, 51",
                    high: "213, 71, 51",
                    color1: "124, 181, 236",
                    color2: "67, 67, 72",
                    color3: "144, 237, 125",
                    color4: "247, 163, 92"
                }
            };
            this.init(config);
        }

        init(config) {
            this.loadDataChart(config, this.settings);
            this.createGrid(config);
        }

        loadDataChart(config, settings) {
            const cardActions = $('.loading').parents('.card').find('.card-header').find('.actions');
            $(document).bind('ajaxStart', function() {
                $('.loading').show('fast');
                $('.chart-title').hide();
                cardActions.css('opacity', 0);
            })
                .bind('ajaxStop', function() {
                    $('.loading').animate({
                        opacity: 0
                    }, function() {
                        $(this).hide();
                    });
                    $('.chart-title').show();
                    cardActions.css('opacity', 1);
                });

            ApiConnect.get(config.chart_data_url)
                .then(data => {
                    this.drawCharts(data, settings, config);
                    this.setCardHeaders(config, settings, data);
                })
                .catch(function(errorThrown) {
                    console.log('Błąd wczytywania danych: ', errorThrown);
                }).finally(() => {
                    $('.loading').animate({
                        opacity: 0
                    }, function() {
                        $(this).hide();
                    });
                    $('.chart-title').show();
                    cardActions.css('opacity', 1);
                });
        }

        setCardHeaders(config, settings, data) {
            $('#' + settings["charts"]["barChart"]["id"]).parents('.card').find('.chart-title').text(config["bar_chart_title"]);

            $('.pie-charts .char-tab').removeClass('active');
            const keys = Object.keys(settings["charts"]["pieCharts"]);

            $('#' + settings["charts"]["pieCharts"][keys[0]]["id"]).parents('.card').find('.chart-title').text(data["data"][settings["charts"]["pieCharts"][keys[0]]["dataName"]]["name"]);
            $('#' + settings["charts"]["pieCharts"][keys[0]]["id"] + 'Tab').addClass('active');

            // noinspection JSUnusedLocalSymbols
            $.each(settings["charts"]["pieCharts"], function(index, val) {
                $('.pie-chart-menu').append('<li><a href="#' + settings["charts"]["pieCharts"][index]["id"] + 'Tab" class="char-tab-toggle">' + data["data"][settings["charts"]["pieCharts"][index]["dataName"]]["name"] + '</a></li>');
            });

            this.bindChangeTabPieChart();
        }

        bindChangeTabPieChart() {
            $('.char-tab-toggle').on('click', function(e) {
                e.preventDefault();
                const $target = $($(this).attr('href'));
                if ($target.length) {
                    $target.siblings().removeClass('active');
                    $target.addClass('active');
                }
                $(this).closest('.card-header').find('h2').text($(this).text());
            })
        }

        drawCharts(data, settings, config) {
            //wykresy belkowe
            //----------------------------------------
            this.chartVulnerabilitiesNumber = new NS.Charts.BarChart({
                "container-id": settings["charts"]["barChart"]["chartVulnerabilitiesNumber"]["id"],
                "data": data["data"][settings["charts"]["barChart"]["chartVulnerabilitiesNumber"]["dataName"]],
                "multidata": false,
                'show_legend' : config['show_legend'],
                labelLength: 15
            });

            this.chartVulnerabilitiesNumber = new NS.Charts.BarChart({
                "container-id": settings["charts"]["barChart"]["chartAnalysisNumber"]["id"],
                "data": data["data"][settings["charts"]["barChart"]["chartAnalysisNumber"]["dataName"]],
                "multidata": true,
                'show_legend' : config['show_legend'],
                labelLength: 15
            });

            this.chartCriticalityDistribution = new NS.Charts.BarChart({
                "container-id": settings["charts"]["barChart"]["chartCriticalityDistribution"]["id"],
                "data": data["data"][settings["charts"]["barChart"]["chartCriticalityDistribution"]["dataName"]],
                "multidata": true,
                "colors": {
                    "low": settings["colors"]["low"],
                    "medium": settings["colors"]["medium"],
                    "high": settings["colors"]["high"]
                },
                "name_mapping": {
                    "low": "Niski",
                    "medium": "Średni",
                    "high": "Wysoki"
                },
                'show_legend' : config['show_legend'],
                labelLength: 15
            });

            //wykresy pie
            //----------------------------------------
            this.chartCriticalityVulnerabilityAnalysis = new NS.Charts.PieChart({
                "container-id": settings["charts"]["pieCharts"]["chartCriticalityVulnerabilityDistribution"]["id"],
                "data": data["data"][settings["charts"]["pieCharts"]["chartCriticalityVulnerabilityDistribution"]["dataName"]],
                "colors": {
                    "low": settings["colors"]["low"],
                    "medium": settings["colors"]["medium"],
                    "high": settings["colors"]["high"]
                },
                "name_mapping": {
                    "low": "Niski",
                    "medium": "Średni",
                    "high": "Wysoki"
                },
                'show_legend' : config['show_legend']
            });

            this.criticalityVulnerabilityDistributionChart = new NS.Charts.PieChart({
                "container-id": settings["charts"]["pieCharts"]["chartCriticalityVulnerabilityAnalysis"]["id"],
                "data": data["data"][settings["charts"]["pieCharts"]["chartCriticalityVulnerabilityAnalysis"]["dataName"]],
                'show_legend' : config['show_legend']
            });
        }

        createGrid(config) {
            const columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
                "columnDefinitions": [{
                    "label": "Kategoria podatności",
                    "dataIndex": "category",
                    "dataType": "text",
                    "isEditable": false,
                    "isSortable": true,
                    "isFilterable": true,
                    "isMovable": true,
                    width: '*'
                }, {
                    "label": "Krytyczność podatności",
                    "dataIndex": "criticality",
                    "dataType": "importants",
                    "isEditable": false
                }, {
                    "label": "Analiza podatności",
                    "dataIndex": "vulnerability_analysis",
                    "dataType": "text",
                    "isEditable": false

                }, {
                    "label": "Nazwa pliku",
                    "dataIndex": "file_name",
                    "dataType": "text",
                    "isEditable": false

                }, {
                    "label": "Akcje",
                    "dataIndex": "actions",
                    "dataType": "link",
                    "isEditable": false,
                    "isFilterable": false,
                    "isSortable": false,
                    "width": 120
                }]
            });

            const dataSource = new NS.Grid.SimpleDataSource({
                'url': config.table_data_url,
                'baseParameters': {},
                'updateUrl': "/js/app/update.json"
            });

            const settingsManager = new NS.Grid.CookiesSettingsManager({
                "id": "gridContainerId"
            });

            new NS.Grid.Control({
                'id': "gridContainerWrapperId",
                'containerId': 'grid-container',
                'dataSource': dataSource,
                'reloadTime': null, //not implemented yet
                'autoLoad': true,
                'columnDefinitionSource': columnDefinitionSource,
                'settingsManager': settingsManager,
                'allowMultiselect': false,
                "showAllRows": config.show_all_rows || false,
                "pageSize": (config.show_all_rows) ? 99999999 : 20,
                'listeners': {
                    'onDataChanged': function () {

                    },
                    'onDataSaved': function () {

                    },
                    'onDataInvalid': function () {

                    },
                    'onDataError': function () {

                    },
                    'onSelectionChange': function (ids) {

                    }
                }
            });
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Views = global.NS.Views || {};
    global.NS.Views.FortifyPreviewController = FortifyPreviewController || {};

})(window);
